<template>
	<MarkdownPage>
		<MarkdownHeader
			:title="$t('tos.title')"
		/>
		<MarkdownContent
			:html="$t('tos.copy')"
		/>
	</MarkdownPage>
</template>

<script setup>
import { MarkdownHeader } from '#components'
import {
	BASE_URL,
	COMPANY_NAME
} from '@/constants/index.js'
import { useI18n } from 'vue-i18n'

const { t } = useI18n({
	useScope: 'global'
})

useHead({
	title: t('tos.meta-title'),
	meta: [
		{ name: 'url',
			content: `${BASE_URL}/tos` },
		{ name: 'description',
			content: t('tos.meta-description', { COMPANY_NAME }) }
	]
})
</script>
